const QUERIES = {
  USERS_LIST: "users-list",
};

const QUERIESVISITORS = {
  VISITORS_LIST: "visitors-list",
};

export { QUERIES, QUERIESVISITORS };
